import {
    Persona,
    PersonaFormValues,
} from '../types';

// Turns a stored Persona (which may have actionCodes: NULL and lifecycle: NULL —
// the existing dev "Email User" persona does) into form values the inputs can
// always write into. A NULL lifecycle becomes three blank fields the user can
// FILL IN, rather than a missing object that the form could only replace.
export const buildInitialValues = (record?: Persona): PersonaFormValues => {
    return {
        id: record?.id ?? '',
        name: record?.name ?? '',
        description: record?.description ?? '',
        // Drop AppSync's __typename from the nested objects — it would be
        // rejected as an unknown field inside WeightedActionCodeInput.
        actionCodes: (record?.actionCodes ?? []).map(entry => ({
            actionCode: entry.actionCode,
            weight: entry.weight,
        })),
        // Non-null so the MultiSelect always has an array to write into. A
        // persona authored before FNP-967 has testDefinitionIds: NULL, and the
        // list itself is `[ID]` — nullable ids — so nulls inside it are dropped
        // rather than handed to the select as blank options.
        testDefinitionIds: (record?.testDefinitionIds ?? [])
            .filter((id): id is string => typeof id === 'string' && id !== ''),
        lifecycle: {
            wakeCadenceHours: record?.lifecycle?.wakeCadenceHours ?? '',
            expectedLifespanDays: record?.lifecycle?.expectedLifespanDays ?? '',
            cancellationLikelihoodPercent: record?.lifecycle?.cancellationLikelihoodPercent ?? '',
        },
    };
};
